// 코호트 관리 모달
import { useState } from "react";
import { useTranslation } from "react-i18next";
import styles from "../IntegratedSearchPage.module.css";
import { labelFor } from "../data/searchData";
import { Icon } from "./Icons";

export function CohortModal({ cohorts, chips, onAdd, onRemove, onApply, onClose }) {
    const { t } = useTranslation();
    const [name, setName] = useState("");
    const [busy, setBusy] = useState(false);
    const activeSummary = Object.entries(chips).filter(([, vs]) => vs?.length)
        .map(([k, vs]) => `${k}: ${vs.map(labelFor).join(", ")}`).join(" · ") || t('적용한 필터 없음');

    const handleAdd = async () => {
        if (!name.trim()) return;
        setBusy(true);
        try { await onAdd(name.trim()); setName(""); } finally { setBusy(false); }
    };

    return (
        <>
            <div className={styles.modalBackdrop} onClick={onClose} />
            <div className={styles.modal} role="dialog" aria-modal="true">
                <div className={styles.modalHeader}>
                    <span className={styles.modalTitle}><Icon.Star /> {t('저장된 코호트')}</span>
                    <button className={styles.iconBtn} onClick={onClose}><Icon.X /></button>
                </div>
                <div className={styles.modalBody}>
                    <div className={styles.modalAddBox}>
                        <div className={styles.fieldLabel}>{t('현재 필터를 코호트로 저장')}</div>
                        <div className={styles.modalCurrentFilters}>{activeSummary}</div>
                        <div className={styles.modalAddRow}>
                            <input className={styles.modalInput} placeholder={t('코호트 이름')}
                                value={name} onChange={(e) => setName(e.target.value)}
                                onKeyDown={(e) => e.key === "Enter" && handleAdd()} />
                            <button className={styles.primaryBtn} onClick={handleAdd} disabled={busy || !name.trim()}><Icon.Plus /> {t('추가')}</button>
                        </div>
                    </div>
                    <div className={styles.modalListLabel}>{t('저장된 코호트')} ({cohorts.length})</div>
                    <div className={styles.modalList}>
                        {cohorts.map((c) => (
                            <div key={c.id} className={styles.modalItem}>
                                <button className={styles.modalItemMain} onClick={() => onApply(c)} title={t('적용')}><Icon.Star /> <span className={styles.savedItemName}>{c.name}</span></button>
                                <button className={styles.modalDeleteBtn} onClick={() => onRemove(c.id)} title={t('삭제')}><Icon.X /></button>
                            </div>
                        ))}
                        {cohorts.length === 0 && <div className={styles.modalEmpty}>{t('저장된 코호트 없음')}</div>}
                    </div>
                </div>
            </div>
        </>
    );
}